/* IDEAS:
- background / gradient
- different noise layers?
- toggles for pulse, tags, bgdots, blurdots
*/
import Knobs from '../lib/knobs.min';


//document.body.innerHTML += '<canvas id="canvas"></canvas>';
let parentDiv = document.getElementById('firstSection');
// console.log(parentDiv)
if (parentDiv != null) {
    var canvasNode = document.createElement('canvas');
    canvasNode.setAttribute('id', 'canvas');
    let childnode = parentDiv.firstChild;
    parentDiv.insertBefore(canvasNode, childnode);

    var canvas = document.getElementById("canvas");
    var first = document.getElementsByClassName("firstSection")[0];
    var ctx = canvas.getContext("2d");
    var w, h;
    var tagTypes, dots, dotsBG, dotsBlur = [];

    window.onresize = function () {
        w = ctx.canvas.width = window.innerWidth;
        h = ctx.canvas.height = ctx.canvas.height = document.getElementById('firstSection').offsetHeight;
    };
    window.onresize();

    var nt = 0;

    var config = {
        lighten: false,
        colorBG: "#102342",// "#010317",#102342
        noiseSpeed: 0.003,
        noiseScale: 150,
        noiseVel: 1,
        glow: 0,
        dots: {
            count: 45,
            radius: 5,
            pulseWidth: 1,
            lineWidth: 0,//1,
            pulseCounter: 300,
            pulseDist: 30,
            tagCounter: 50,
            distance: 0,
            color: "#70caff",
            xVel: 0.6,
            yVel: 0.35,
            hasTag: 0.4,
            hasPulse: 0.8
        },
        bgDots: {
            count: 60,
            radius: 2,
            lineWidth: 0,
            distance: 0,
            color: "#003757"
        },
        blurDots: {
            count: 0,
            radius: 120,
            color: "#001633"
        }
    };

    const gui = {
        knobsToggle: false,
        visible: 0,
        knobs: [
            "General",
            {
                label: "Speed",
                type: "range",
                value: config.noiseVel,
                min: 0.1,
                max: 3,
                step: 0.05,
                onChange: function (e, v) {
                    config.noiseVel = v.value;
                }
            },
            {
                label: "Noise Speed",
                type: "range",
                value: config.noiseSpeed,
                min: 0.0001,
                max: 0.01,
                step: 0.0001,
                onChange: function (e, v) {
                    config.noiseSpeed = v.value;
                }
            },
            {
                label: "Glow",
                type: "range",
                value: config.glow,
                min: 0,
                max: 30,
                step: 1,
                onChange: function (e, v) {
                    config.glow = v.value;
                }
            },
            {
                label: "Background",
                type: "color",
                value: config.colorBG,
                onChange: function (e, v) {
                    config.colorBG = v.value;
                }
            },
            "Main Dots",
            {
                label: "Count",
                type: "range",
                value: config.dots.count,
                min: 10,
                max: 100,
                step: 1,
                onChange: function (e, v) {
                    config.dots.count = v.value;
                    reset();
                }
            },
            {
                label: "Radius",
                type: "range",
                value: config.dots.radius,
                min: 1,
                max: 10,
                step: 0.1,
                onChange: function (e, v) {
                    config.dots.radius = v.value;
                }
            },
            {
                label: "Line Width",
                type: "range",
                value: config.dots.lineWidth,
                min: 0.5,
                max: 5,
                step: 0.1,
                onChange: function (e, v) {
                    config.dots.lineWidth = v.value;
                }
            },
            {
                label: "Pulse Width",
                type: "range",
                value: config.dots.pulseWidth,
                min: 0.5,
                max: 5,
                step: 0.1,
                onChange: function (e, v) {
                    config.dots.pulseWidth = v.value;
                }
            },
            {
                label: "Pulse Size",
                type: "range",
                value: config.dots.pulseDist,
                min: 10,
                max: 60,
                step: 1,
                onChange: function (e, v) {
                    config.dots.pulseDist = v.value;
                }
            },
            {
                label: "Connection Range",
                type: "range",
                value: config.dots.distance,
                min: 75,
                max: 350,
                step: 1,
                onChange: function (e, v) {
                    config.dots.distance = v.value;
                }
            },
            {
                label: "Pulse Count",
                type: "range",
                value: config.dots.hasPulse,
                min: 0.1,
                max: 1,
                step: 0.1,
                onChange: function (e, v) {
                    config.dots.hasPulse = v.value;
                    reset();
                }
            },
            {
                label: "Tags Count",
                type: "range",
                value: config.dots.hasTag,
                min: 0.1,
                max: 1,
                step: 0.1,
                onChange: function (e, v) {
                    config.dots.hasTag = v.value;
                    reset();
                }
            },
            {
                label: "X Speed",
                type: "range",
                value: config.dots.xVel,
                min: -1,
                max: 1,
                step: 0.05,
                onChange: function (e, v) {
                    config.dots.xVel = v.value;
                }
            },
            {
                label: "Y Speed",
                type: "range",
                value: config.dots.yVel,
                min: -1,
                max: 1,
                step: 0.05,
                onChange: function (e, v) {
                    config.dots.yVel = v.value;
                }
            },
            {
                label: "Color",
                type: "color",
                value: config.dots.color,
                onChange: function (e, v) {
                    config.dots.color = v.value;
                }
            },
            "Background Dots",
            {
                label: "Count",
                type: "range",
                value: config.bgDots.count,
                min: 0,
                max: 100,
                step: 1,
                onChange: function (e, v) {
                    config.bgDots.count = v.value;
                    reset();
                }
            },
            {
                label: "Radius",
                type: "range",
                value: config.bgDots.radius,
                min: 0.5,
                max: 5,
                step: 0.1,
                onChange: function (e, v) {
                    config.bgDots.radius = v.value;
                }
            },
            {
                label: "Line Width",
                type: "range",
                value: config.bgDots.lineWidth,
                min: 0.5,
                max: 2,
                step: 0.1,
                onChange: function (e, v) {
                    config.bgDots.lineWidth = v.value;
                }
            },
            {
                label: "Connection Range",
                type: "range",
                value: config.bgDots.distance,
                min: 30,
                max: 150,
                step: 1,
                onChange: function (e, v) {
                    config.bgDots.distance = v.value;
                }
            },
            {
                label: "Color",
                type: "color",
                value: config.bgDots.color,
                onChange: function (e, v) {
                    config.bgDots.color = v.value;
                }
            },
            "Blur Dots",
            {
                label: "Count",
                type: "range",
                value: config.blurDots.count,
                min: 0,
                max: 20,
                step: 1,
                onChange: function (e, v) {
                    config.blurDots.count = v.value;
                    reset();
                }
            },
            {
                label: "Radius",
                type: "range",
                value: config.blurDots.radius,
                min: 30,
                max: 150,
                step: 1,
                onChange: function (e, v) {
                    config.blurDots.radius = v.value;
                }
            },
            {
                label: "Color",
                type: "color",
                value: config.blurDots.color,
                onChange: function (e, v) {
                    config.blurDots.color = v.value;
                }
            }
        ]
    };

    tagTypes = ["letters", "numbers", "all"];

    class Dot {
        constructor() {
            this.pos = {
                x: Math.random() * w,
                y: Math.random() * h
            };
            this.vel = {
                x: 0,
                y: 0
            };
            this.pulseProg = Math.random() * config.dots.pulseCounter;
            this.pulseVal = 0;
            this.hasPulse = Math.random() < config.dots.hasPulse;
            this.tagProg = Math.random() * config.dots.tagCounter;
            this.tagSpeed = Math.random() * (15 - 1) + 1;
            this.hasTag = Math.random() < config.dots.hasTag;
            this.tag = generateTag(
                4,
                tagTypes[Math.floor(Math.random() * tagTypes.length)]
            );
            this.radiusMul = Math.random() * (1.5 - 0.5) + 0.5;
        }

        drawTag() {
            if (!this.hasTag) return;

            var rad = this.radiusMul * config.dots.radius;
            this.tagProg += this.tagSpeed;
            if (this.tagProg > config.dots.tagCounter) {
                this.tagProg = 0;
                this.tag = generateTag(
                    4,
                    tagTypes[Math.floor(Math.random() * tagTypes.length)]
                );
            }
            ctx.fillStyle = config.dots.color;
            ctx.textAlign = "right";
            ctx.font = "12px Alarm Clock";
            ctx.fillText(this.tag, this.pos.x - rad, this.pos.y + rad + 5);
        }

        draw() {
            var rad = this.radiusMul * config.dots.radius;

            ctx.beginPath();
            ctx.fillStyle = config.dots.olor;
            ctx.arc(this.pos.x, this.pos.y, rad, 0, 2 * Math.PI);
            ctx.fill();
            ctx.closePath();
        }

        move(i) {
            this.vel.x =
                noise.perlin3(this.pos.y / config.noiseScale, i / 50, nt) *
                config.noiseVel;
            this.vel.y =
                noise.perlin3(this.pos.x / config.noiseScale, i / 50, nt) *
                config.noiseVel;

            this.pos.x += this.vel.x + config.dots.xVel;
            this.pos.y += this.vel.y + config.dots.yVel;
        }

        collision() {
            var rad = this.radiusMul * config.dots.radius;

            if (this.pos.x < 0 - rad) this.pos.x = w + rad;

            if (this.pos.x > w + rad) this.pos.x = 0 - rad;

            if (this.pos.y < 0 - rad) this.pos.y = h + rad;

            if (this.pos.y > h + rad) this.pos.y = 0 - rad;
        }

        connect(dot1, dot2, bg) {
            var dotDist = dist(dot1.pos.x, dot2.pos.x, dot1.pos.y, dot2.pos.y);

            if (dotDist <= config.dots.distance) {
                var proDist = 100 / config.dots.distance;
                var opacity = 1 - (dotDist * proDist) / 100;
                var col = hexToRGB(config.dots.color);

                ctx.beginPath();
                ctx.moveTo(dot1.pos.x, dot1.pos.y);
                ctx.strokeStyle =
                    "rgba(" + col.r + ", " + col.g + ", " + col.b + ", " + opacity + ")";
                ctx.lineWidth = config.dots.lineWidth;
                ctx.lineTo(dot2.pos.x, dot2.pos.y);
                ctx.stroke();
                ctx.closePath();
            }
        }

        pulse() {
            if (!this.hasPulse) return;

            if (this.pulseProg >= config.dots.pulseCounter) {
                this.pulseVal += 0.3;
            }

            if (this.pulseVal >= config.dots.pulseDist) {
                this.pulseVal = 0;
                this.pulseProg = 0;
            }
            this.pulseProg += 1;

            var proDist = 100 / config.dots.pulseDist;
            var opacity = 1 - (this.pulseVal * proDist) / 100;
            var col = hexToRGB(config.dots.color);

            ctx.beginPath();
            ctx.strokeStyle =
                "rgba(" + col.r + ", " + col.g + ", " + col.b + ", " + opacity + ")";
            ctx.lineWidth = config.dots.pulseWidth;
            ctx.arc(this.pos.x, this.pos.y, this.pulseVal, 0, 2 * Math.PI);
            ctx.stroke();
            ctx.closePath();
        }
    }

    class DotBG {
        constructor() {
            this.pos = {
                x: Math.random() * w,
                y: Math.random() * h
            };
            this.vel = {
                x: 0,
                y: 0
            };
        }

        draw() {
            ctx.beginPath();
            ctx.fillStyle = config.bgDots.color;
            ctx.arc(this.pos.x, this.pos.y, config.bgDots.radius, 0, 2 * Math.PI);
            ctx.fill();
            ctx.closePath();
        }

        move(i) {
            this.vel.x = noise.perlin3(this.pos.y / 400, i / 10, nt) * config.noiseVel;
            this.vel.y = noise.perlin3(this.pos.x / 400, i / 10, nt) * config.noiseVel;

            this.pos.x += this.vel.x;
            this.pos.y += this.vel.y;
        }

        collision() {
            if (this.pos.x < 0 - config.bgDots.radius)
                this.pos.x = w + config.bgDots.radius;

            if (this.pos.x > w + config.bgDots.radius)
                this.pos.x = 0 - config.bgDots.radius;

            if (this.pos.y < 0 - config.bgDots.radius)
                this.pos.y = h + config.bgDots.radius;

            if (this.pos.y > h + config.bgDots.radius)
                this.pos.y = 0 - config.bgDots.radius;
        }

        connect(dot1, dot2, bg) {
            var dotDist = dist(dot1.pos.x, dot2.pos.x, dot1.pos.y, dot2.pos.y);

            if (dotDist <= config.bgDots.distance) {
                var proDist = 100 / config.bgDots.distance;
                var opacity = 1 - (dotDist * proDist) / 100;
                var col = hexToRGB(config.bgDots.color);

                ctx.beginPath();
                ctx.moveTo(dot1.pos.x, dot1.pos.y);
                ctx.strokeStyle =
                    "rgba(" + col.r + ", " + col.g + ", " + col.b + ", " + opacity + ")";
                ctx.lineWidth = config.bgDots.lineWidth;
                ctx.lineTo(dot2.pos.x, dot2.pos.y);
                ctx.stroke();
                ctx.closePath();
            }
        }
    }

    class DotBlur {
        constructor() {
            this.pos = {
                x: Math.random() * w,
                y: Math.random() * h
            };
            this.vel = {
                x: 0,
                y: 0
            };
            this.radiusMul = Math.random() * (1.5 - 0.5) + 0.5;
        }

        draw() {
            var rad = this.radiusMul * config.blurDots.radius;

            var col = hexToRGB(config.blurDots.color);
            var grd = ctx.createRadialGradient(
                this.pos.x,
                this.pos.y,
                0,
                this.pos.x,
                this.pos.y,
                rad
            );
            grd.addColorStop(
                0,
                "rgba(" + col.r + ", " + col.g + ", " + col.b + ", 0.8)"
            );
            grd.addColorStop(1, "rgba(" + col.r + ", " + col.g + ", " + col.b + ", 0)");

            ctx.beginPath();
            ctx.fillStyle = grd;
            ctx.arc(this.pos.x, this.pos.y, rad, 0, 2 * Math.PI);
            ctx.fill();
            ctx.closePath();
        }

        move(i) {
            this.vel.x = noise.perlin3(this.pos.y / 400, i / 10, nt) * config.noiseVel;
            this.vel.y = noise.perlin3(this.pos.x / 400, i / 10, nt) * config.noiseVel;

            this.pos.x += this.vel.x;
            this.pos.y += this.vel.y;
        }

        collision() {
            var rad = this.radiusMul * config.blurDots.radius;

            if (this.pos.x < 0 - rad) this.pos.x = w + rad;

            if (this.pos.x > w + rad) this.pos.x = 0 - rad;

            if (this.pos.y < 0 - rad) this.pos.y = h + rad;

            if (this.pos.y > h + rad) this.pos.y = 0 - rad;
        }
    }

    function reset() {
        dots = [];
        dotsBG = [];
        dotsBlur = [];

        for (var i = 0; i < config.dots.count; i++) {
            var dot = new Dot(i);
            dots.push(dot);
        }

        for (var i = 0; i < config.bgDots.count; i++) {
            var dot = new DotBG(i);
            dotsBG.push(dot);
        }

        for (var i = 0; i < config.blurDots.count; i++) {
            var dot = new DotBlur(i);
            dotsBlur.push(dot);
        }
    }

    function render() {
        ctx.shadowColor = config.dots.color;
        ctx.shadowBlur = 0;

        nt += config.noiseSpeed;
        ctx.clearRect(0, 0, w, h);
        ctx.fillStyle = config.colorBG;
        ctx.fillRect(0, 0, w, h);

        /*if(config.lighten){
          ctx.globalCompositeOperation = "lighter";
        }else{
          ctx.globalCompositeOperation = "source-over";
        }*/

        dotsBlur.forEach((dot, i) => {
            dot.draw();
            dot.move(i);
            dot.collision();
        });

        ctx.shadowColor = config.dots.color;
        ctx.shadowBlur = 0;

        dotsBG.forEach((dot, i) => {
            dotsBG.forEach((dot2, j) => {
                dot.connect(dot, dot2, true);
            });
            dot.draw();
            dot.move(i);
            dot.collision();
        });

        /*var colBG = hexToRGB(config.colorBG);
        ctx.fillStyle = "rgba("+colBG.r+", "+colBG.g+", "+colBG.b+", 0.7)";
        ctx.fillRect(0,0,w,h);*/

        ctx.shadowColor = config.dots.color;
        ctx.shadowBlur = config.glow;

        dots.forEach((dot, i) => {
            dots.forEach((dot2, j) => {
                dot.connect(dot, dot2);
            });
            dot.pulse();
            dot.drawTag();
            dot.draw();
            dot.move(i);
            dot.collision();
        });
        requestAnimationFrame(render);
    }

    reset();
    render();

// const knobs = new Knobs(gui);

    function dist(x1, x2, y1, y2) {
        var a = x1 - x2;
        var b = y1 - y2;

        var c = Math.sqrt(a * a + b * b);
        return c;
    }

    function hexToRGB(hex) {
        var hashed = hex.charAt(0) == "#" ? hex.substring(1, 7) : hex;
        var R = parseInt(hashed.substring(0, 2), 16);
        var G = parseInt(hashed.substring(2, 4), 16);
        var B = parseInt(hashed.substring(4, 6), 16);
        var RGB = `rgb(${R}, ${G}, ${B})`;
        return {
            r: R,
            g: G,
            b: B
        };
    }

    function generateTag(length, type) {
        var result = "";
        if (type == "letters") {
            var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        } else if (type == "numbers") {
            var chars = "0123456789";
        } else {
            var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        }
        for (var i = 0; i < length; i++) {
            if (type == "numbers" && i == 1) {
                result += ":";
            } else {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
        }

        return "";//result;
    }
}